import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { Label } from "@progress/kendo-react-labels";
import React, { FunctionComponent, useState } from 'react'
import { Api } from '../../../redux/api/BaseApi';
import { UserApi } from '../../../redux/api/UserApi';
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';

const StaffList: FunctionComponent<FieldRenderProps> = props => {
  const {
    label,
    id,
    valid,
    disabled,
    optional,
    values,
    multiSelect,
    addSelect,
    companyId,
    showMe,
    currentUserTop,
    showAddButton,
    addClicked
  } = props;

  const { data: staff } = UserApi.useGetStaffQuery({ teamId: undefined, includeQueues: false, includeStaffPlusForCompanyId: companyId || 0 });
  const [opened, setOpened] = useState(false);

  //Show current user as "Me"
  const { data: userProfile } = Api.useGetUserProfileQuery();
  let bindStaff = showMe ? staff?.map(s => { return { ...s, Full_Name: s.ID === userProfile.Id ? '<Me>' : s.Full_Name } }) : staff;
  bindStaff = currentUserTop ? bindStaff?.sort(function (x, y) { return x.ID === userProfile.Id ? -1 : y.ID === userProfile.Id ? 1 : 0; }) : bindStaff;

  const currentValues = values?.length > 0 ? bindStaff?.filter(i => values?.indexOf(i.ID) > -1) : undefined;
  const fieldChanged = (e) => {
    props.onChange({ value: [e.value.ID] });
  }
  const multiFieldChanged = (e) => {
    let newValues = e.value.map(v => v.ID);
    props.onChange({ value: newValues.length ? newValues : [null] }); //Null required to remove existing values from multi-select
  }
  const listControl = (
    multiSelect ?
      <MultiSelect popupSettings={{ className: "z500" }} placeholder='Select multiple' onChange={multiFieldChanged} value={currentValues} data={bindStaff} textField="Full_Name" dataItemKey='ID'
        opened={opened}
        onFocus={() => { setOpened(true) }}
        onBlur={() => { setOpened(false) }}
      />
      :
      <DropDownList popupSettings={{ className: "z500", width: 250 }} defaultItem={addSelect ? { Full_Name: "Select" } : undefined} onChange={fieldChanged} value={currentValues?.length > 0 ? currentValues[0] : undefined} data={bindStaff} dataItemKey="ID" textField="Full_Name" />
  )
  return (
    <>
      <Label
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>
      <div className='d-flex'>{listControl}{showAddButton && <Button type='button' title='Multi-staff action' size='small' fillMode='flat' svgIcon={svg.plusCircleIcon} className='add-staff' onClick={() => addClicked()} />}</div>
    </>
  )
}


export default StaffList;